import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import TablesView from './components/views/Tables.vue'
import TasksView from './components/views/Tasks.vue'
import SettingView from './components/views/Setting.vue'
import AccessView from './components/views/Access.vue'
import ServerView from './components/views/Server.vue'
import ReposView from './components/views/Repos.vue'

// Import Pages
import SystemSettingsList from './components/pages/SystemSettingsList.vue'
import SystemSettingsManager from './components/pages/SystemSettingsManager.vue'
import CategoryManager from './components/pages/CategoryManager.vue'
import CategoryL1Manager from './components/pages/CategoryL1Manager.vue'
import CategoryL2Manager from './components/pages/CategoryL2Manager.vue'
import GoodsList from './components/pages/GoodsList.vue'
import GoodsManager from './components/pages/GoodsManager.vue'
import OrderList from './components/pages/OrderList.vue'
import OrderManager from './components/pages/OrderManager.vue'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {title: '总体数据', description: '仪表盘', requiresAuth: true}
      },
      {
        path: 'systemsettings',
        alias: '',
        component: SystemSettingsList,
        name: 'SystemSettingsList',
        meta: {title: '系统配置列表', description: '设置系统属性和外观', requiresAuth: true}
      },
      {
        path: 'systemsettings/create/',
        alias: '',
        component: SystemSettingsManager,
        name: 'SystemSettingsCreate',
        meta: {title: '创建系统配置', description: '创建系统配置', requiresAuth: true}
      },
      {
        path: 'systemsettings/detail/:id',
        alias: '',
        component: SystemSettingsManager,
        name: 'SystemSettingsDetail',
        meta: {title: '系统配置详情', description: '系统配置详情', requiresAuth: true}
      },
      {
        path: 'systemsettings/update/:id',
        alias: '',
        component: SystemSettingsManager,
        name: 'SystemSettingsUpdate',
        meta: {title: '系统配置更新', description: '系统配置更新', requiresAuth: true}
      },
      {
        path: 'category',
        alias: '',
        component: CategoryManager,
        name: 'CategoryManager',
        meta: {title: '分类管理', description: '管理商品的可用分类', requiresAuth: true}
      },
      {
        path: 'categoryl1/create/',
        alias: '',
        component: CategoryL1Manager,
        name: 'CategoryL1Create',
        meta: {title: '创建一级分类', description: '创建一级分类', requiresAuth: true}
      },
      {
        path: 'categoryl1/detail/:id',
        alias: '',
        component: CategoryL1Manager,
        name: 'CategoryL1Detail',
        meta: {title: '一级分类详情', description: '一级分类详情', requiresAuth: true}
      },
      {
        path: 'categoryl1/update/:id',
        alias: '',
        component: CategoryL1Manager,
        name: 'CategoryL1Update',
        meta: {title: '一级分类更新', description: '一级分类更新', requiresAuth: true}
      },
      {
        path: 'categoryl2/create/:parentId',
        alias: '',
        component: CategoryL2Manager,
        name: 'CategoryL2Create',
        meta: {title: '创建二级分类', description: '创建二级分类', requiresAuth: true}
      },
      {
        path: 'categoryl2/detail/:id',
        alias: '',
        component: CategoryL2Manager,
        name: 'CategoryL2Detail',
        meta: {title: '二级分类详情', description: '二级分类详情', requiresAuth: true}
      },
      {
        path: 'categoryl2/update/:id',
        alias: '',
        component: CategoryL2Manager,
        name: 'CategoryL2Update',
        meta: {title: '二级分类更新', description: '二级分类更新', requiresAuth: true}
      },
      {
        path: 'goods',
        alias: '',
        component: GoodsList,
        name: 'GoodsList',
        meta: {title: '商品列表', description: '全部商品', requiresAuth: true}
      },
      {
        path: 'goods/create/',
        alias: '',
        component: GoodsManager,
        name: 'GoodsCreate',
        meta: {title: '创建商品', description: '创建商品', requiresAuth: true}
      },
      {
        path: 'goods/detail/:id',
        alias: '',
        component: GoodsManager,
        name: 'GoodsDetail',
        meta: {title: '商品详情', description: '商品详情', requiresAuth: true}
      },
      {
        path: 'goods/update/:id',
        alias: '',
        component: GoodsManager,
        name: 'GoodsUpdate',
        meta: {title: '商品更新', description: '商品更新', requiresAuth: true}
      },
      {
        path: 'order',
        alias: '',
        component: OrderList,
        name: 'OrderList',
        meta: {title: '订单列表', description: '全部订单', requiresAuth: true}
      },
      {
        path: 'order/create/',
        alias: '',
        component: OrderManager,
        name: 'OrderCreate',
        meta: {title: '创建订单', description: '创建订单', requiresAuth: true}
      },
      {
        path: 'order/detail/:id',
        alias: '',
        component: OrderManager,
        name: 'OrderDetail',
        meta: {title: '订单详情', description: '订单详情', requiresAuth: true}
      },
      {
        path: 'order/update/:id',
        alias: '',
        component: OrderManager,
        name: 'OrderUpdate',
        meta: {title: '订单更新', description: '订单更新', requiresAuth: true}
      },

      /* Sample Views */
      {
        path: 'tables',
        component: TablesView,
        name: 'Tables',
        meta: {description: 'Simple and advance table in CoPilot', requiresAuth: true}
      }, {
        path: 'tasks',
        component: TasksView,
        name: 'Tasks',
        meta: {description: 'Tasks page in the form of a timeline', requiresAuth: true}
      }, {
        path: 'setting',
        component: SettingView,
        name: 'Settings',
        meta: {description: 'User settings page', requiresAuth: true}
      }, {
        path: 'access',
        component: AccessView,
        name: 'Access',
        meta: {description: 'Example of using maps', requiresAuth: true}
      }, {
        path: 'server',
        component: ServerView,
        name: 'Servers',
        meta: {description: 'List of our servers', requiresAuth: true}
      }, {
        path: 'repos',
        component: ReposView,
        name: 'Repository',
        meta: {description: 'List of popular javascript repos', requiresAuth: true}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js